export default __webpack_public_path__ + "static/media/galery_photo3@2x.47a258bf.png";